import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import de from 'date-fns/locale/de';

import type { TimeSlotType } from '@widget/api/types';

export const getTimeSlotDays = (
  timeslots: Record<string, { slots: TimeSlotType[] }>,
  timezone: string,
) => {
  let firstTimeslotDate = null;
  const days = Object.keys(timeslots)
    .sort((a, b) => parseISO(a).getTime() - parseISO(b).getTime())
    .map((date: string) => ({
      date,
      dateFormated: formatInTimeZone(date, timezone, 'dd MMMM', { locale: de }),
      weekDay: formatInTimeZone(date, timezone, 'EEEE', { locale: de }),
      disabled: timeslots[date].slots.length === 0,
    }));

  //set first optimal slot as selected
  days.find((d) => {
    const firstSlot = timeslots[d.date].slots.find((s) => s.isoDateTime);
    if (firstSlot) {
      firstTimeslotDate = d.date;
      return true;
    }
  });
  // set first day as selected in case there is no optimal slots
  if (!firstTimeslotDate) {
    firstTimeslotDate = days[0].date;
  }

  return { days, firstTimeslotDate };
};

export const getTotalTimeSlots = (timeslots: Record<string, { slots: TimeSlotType[] }>) => {
  let total = 0;
  let totalOptimalSlots = 0;
  for (const day in timeslots) {
    timeslots[day].slots.forEach((slot: TimeSlotType) => {
      slot.isOptimal && totalOptimalSlots++;
      total++;
    });
  }
  return { timeslots, total, totalOptimalSlots };
};
